module.exports = __webpack_public_path__ + "media/components/common/loader/loader-c3006e9ce3882c2c6fa8abe92171a791e7913a65e4cfbe8b1ff89141084332d3.svg";